import { Controller } from "react-hook-form";
import { ContentPageEditProps } from "..";
import FormFieldErrors from "../../Form/FormFieldErrors";
import SocialMediaLinksInput from "../../Inputs/SocialMediaLinksInput";
import Form from "../../Form";
import { useSiteState } from "../../../utils/useSiteState";

const ContentPageEditSupportSocialLinks: React.FC<ContentPageEditProps> = ({
  page,
}) => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { page_template_config } = page;

    return {
      page_template_config,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update Social Links"
      endpoint={`sites/${site.id}/pages/${page.id}`}
      method="put"
      className="w-full text-white"
      render={({ errors, control }) => (
        <>
          <div className="my-10">
            <Controller
              name="page_template_config.social_media_icons"
              control={control}
              defaultValue=""
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <SocialMediaLinksInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.page_template_config?.social_media_icons}
                  placeholder="Social Media Links"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="page_template_config.social_media_icons"
            />
          </div>
        </>
      )}
    />
  );
};

export default ContentPageEditSupportSocialLinks;
